import React from 'react'
import { Link } from 'gatsby'

import LayoutSidebar from '../LayoutSidebar'

const socialMedia = [
  {
    name: 'Twitter',
    href: 'https://twitter.com/versettinc/',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/versettinc/',
  },

  {
    name: 'Medium',
    href: 'https://medium.com/curated-by-versett',
  },
  {
    name: 'Dribbble',
    href: 'https://dribbble.com/versett',
  },
]

export default ({ offices, compact }) => {
  if (compact) {
    return (
      <React.Fragment>
        <footer className="s-footer s-container">
          <div className="s-footer__nav grid grid--2col-1-2">
            <small>&copy; Versett {new Date().getFullYear()}</small>
            <div>
              <a href="https://twitter.com/versettinc/">Twitter</a>
              <a href="https://www.instagram.com/versettinc/">Instagram</a>
              <a href="https://medium.com/curated-by-versett">Medium</a>
              <a href="https://dribbble.com/versett">Dribbble</a>
            </div>
          </div>
        </footer>
      </React.Fragment>
    )
  } else
    return (
      <React.Fragment>
        <footer className="s-footer s-container">
          <div className="s-footer__logo">
            <svg
              viewBox="0 0 436 236"
              xmlns="http://www.w3.org/2000/svg"
              width="52"
            >
              <path d="M48.88.89l73.26 170.25L196.43.89h48.5L137.62 235.11h-31L.38.89h48.5zM297.54 1L190.47 235H233L340.11 1h-42.57zm95.51 0L286 235h42.56L435.62 1h-42.57z" />
            </svg>
          </div>
          <LayoutSidebar classes="s-footer__body">
            <div>
              <div>
                <address className="address">
                  <div className="address__name">
                    <Link to="/contact">Contact Us</Link>
                  </div>
                  <div className="address__email">
                    <a href="mailto:hi@versett.com">hi@versett.com</a>
                  </div>
                  <div className="address__phone">
                    <a href="tel:18448377388">1-844-VERSETT</a>
                  </div>
                </address>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                flexWrap: 'wrap',
              }}
            >
              <address>
                <div className="address__name">Locations</div>
                <section>
                  {offices.map((office, index) => (
                    <a
                      href={`https://www.google.ca/maps/place/${office.street} ${office.city} ${office.province_state} ${office.postal_code} ${office.country}`.replace(
                        /\s+/g,
                        '+'
                      )}
                      key={index}
                    >
                      <div className="address__street">{office.name}</div>
                    </a>
                  ))}
                </section>
              </address>
              <address>
                <div className="address__name">Find Us</div>
                <section>
                  {socialMedia.map((media, index) => (
                    <a href={media.href} key={index}>
                      <div className="address__street">{media.name}</div>
                    </a>
                  ))}
                </section>
              </address>
            </div>
          </LayoutSidebar>
          <div className="s-footer__nav grid grid--2col-1-2">
            <small>&copy; Versett {new Date().getFullYear()}</small>
          </div>
        </footer>
      </React.Fragment>
    )
}
